
const images = [
  { img: require('../assets/images/1.png') },
  { img: require('../assets/images/2.png') },
  { img: require('../assets/images/3.png') },
  { img: require('../assets/images/4.png') },
  { img: require('../assets/images/5.png') },
  { img: require('../assets/images/6.png') },
  { img: require('../assets/images/7.png') },
  { img: require('../assets/images/8.png') },
  { img: require('../assets/images/9.png') },
  { img: require('../assets/images/10.png') },
  { img: require('../assets/images/11.png') },
  { img: require('../assets/images/12.png') },
  { img: require('../assets/images/13.png') },
  { img: require('../assets/images/14.png') },
  { img: require('../assets/images/15.png') },
  { img: require('../assets/images/16.png') },
  { img: require('../assets/images/17.png') },
  { img: require('../assets/images/18.png') },
  { img: require('../assets/images/19.png') },
  { img: require('../assets/images/20.png') },
  { img: require('../assets/images/21.png') },
  { img: require('../assets/images/22.png') },
  { img: require('../assets/images/23.png') },
  { img: require('../assets/images/24.png') },
  { img: require('../assets/images/25.png') },
  { img: require('../assets/images/26.png') },
  { img: require('../assets/images/27.png') },
  { img: require('../assets/images/28.png') },
  { img: require('../assets/images/29.png') },
  { img: require('../assets/images/30.png') },
  { img: require('../assets/images/31.png') },
  { img: require('../assets/images/32.png') },
];

export default images;